<template>
  <div class="project-range">
    <div class="header-section">
      <h2>设置项目范围</h2>
    </div>
    <el-table :data="projectList" style="width: 100%" border>
      <el-table-column prop="name" label="项目名称" align="center" width="300"/>
      <el-table-column label="项目范围" align="center" >
        <template slot-scope="scope">
          <el-input v-model="scope.row.scope" placeholder="请输入项目范围" type="text" style="width: 90%;"/>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 24px; text-align: right; display: flex; justify-content: flex-end; align-items: center; gap: 16px;">
      <el-button type="primary" @click="saveTargets">保存</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'ProjectRange',
  data() {
    return {
      projectList: [],
      targetDate: '',
      quickDate: 'yesterday'
    }
  },
  mounted() {
    this.setToday();
    this.loadTargets();
  },
  methods: {
    setToday() {
      const today = new Date();
      const y = today.getFullYear();
      const m = String(today.getMonth() + 1).padStart(2, '0');
      const d = String(today.getDate()).padStart(2, '0');
      this.targetDate = `${y}-${m}-${d}`;
    },
    onDateChange() {
      this.loadTargets();
    },
    onQuickDateChange() {
      if (!this.quickDate) return;

      const today = new Date();
      let targetDate = new Date();

      switch (this.quickDate) {
        case 'yesterday':
          targetDate.setDate(today.getDate() - 1);
          break;
        case 'dayBeforeYesterday':
          targetDate.setDate(today.getDate() - 2);
          break;
        case 'threeDaysAgo':
          targetDate.setDate(today.getDate() - 3);
          break;
      }

      const y = targetDate.getFullYear();
      const m = String(targetDate.getMonth() + 1).padStart(2, '0');
      const d = String(targetDate.getDate()).padStart(2, '0');
      const targetNumber = `${y}-${m}-${d}`;

      this.loadTargets(targetNumber);
    },
    async loadTargets() {
      try {
        // 获取用户信息
        const userInfoRes = await axios.get('/api/user/info');
        const userInfo = userInfoRes.data;
        const authority = userInfo.authority;
        const employeeId = userInfo.employeeId;
        
        let url;
        if (authority == 1) {
          url = `/api/projectScopes`;
        } else {
          url = `/api/projectScopes/getAllProjectWithEmployee?employeeId=${employeeId}`;
        }
        
        const response = await axios.get(url);
        if (response.data.success) {
          // 根据order字段进行排序，从小到大
          this.projectList = response.data.data;
        } else {
          this.$message.error('获取目标数失败: ' + (response.data.message || '未知错误'));
        }
      } catch (error) {
        this.$message.error('获取目标数失败: ' + error);
      }
    },
    moveUp(index) {
      if (index > 0) {
        // 创建新数组来触发响应式更新
        const newList = [...this.projectList];
        const temp = newList[index];
        newList[index] = newList[index - 1];
        newList[index - 1] = temp;
        this.projectList = newList;
      }
    },
    moveDown(index) {
      if (index < this.projectList.length - 1) {
        // 创建新数组来触发响应式更新
        const newList = [...this.projectList];
        const temp = newList[index];
        newList[index] = newList[index + 1];
        newList[index + 1] = temp;
        this.projectList = newList;
      }
    },
    saveTargets() {
      if (!this.targetDate) {
        this.$message.warning('请选择日期');
        return;
      }
      const targets = this.projectList.map((item) => ({
        projectId: item.projectId,
        scope: item.scope,
      }));
      console.log(targets);
      axios.post('/api/projectScopes/addBatch', targets)
          .then(response => {
            if (response.data.success) {
              this.$message.success('保存成功');
              setTimeout(() => {
                this.$router.push({ name: 'ProjectStats' });
              }, 1000);
            } else {
              this.$message.error('保存失败: ' + (response.data.message || '未知错误'));
            }
          })
          .catch(error => {
            this.$message.error('保存失败: ' + error);
          });
    },
    cancel() {
      this.$router.push({ name: 'ProjectStats' });
    },
    /*tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return 'even-row';
      }
      return '';
    }*/
  }
}
</script>

<style scoped>
.project-range {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 32px;
  max-width: 1000px;
  margin: 12px auto;
}

.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.header-controls {
  display: flex;
  align-items: center;
  gap: 12px;
}

.even-row {
  background-color: #f5f7fa;
}

/deep/ .el-table .even-row {
  background-color:rgb(160, 202, 244) !important;
}

</style>